<template>
  <div
    :class="{'with-menubar':menubar, 'no-menubar':!menubar}"
  >
    <TitleArea :is-modal=isModal :text=text />
    <div
      id="content-area"
      class="content-area"
      :class="{'content-with-menubar':menubar, 'content-no-menubar':!menubar}"
    >
      <slot name="contents" />
    </div>
  </div>
</template>

<script>
import TitleArea from '@/components/Atoms/TitleArea'

export default {
  name: 'title-frame',
  components: {
    TitleArea
  },
  props: {
    text: { type: String },
    menubar: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.content-area {
  // height:calc(100% - 8rem);
  margin: $no-margin $little-margin;
  position: fixed;
  width: 95%;
  top: 3rem;
  overflow: scroll;
}
.content-with-menubar{
  height: calc(100% - 10rem);
}
.content-no-menubar{
  height: calc(100% - 4rem);
}
.with-menubar{
  height:calc(100% - 5rem);
}
.no-menubar{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/TitleFrame.vue